/*
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-14 10:03:24
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2026-01-12 13:19:57
 * @FilePath: \git\xht-web-business\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 在导入其他模块之前，先处理二维码扫描场景的 URL 重定向
// 这样可以确保在路由初始化之前完成重定向，避免路由守卫误判
if (typeof window !== 'undefined') {
  const pathname = window.location.pathname
  const search = window.location.search
  const hash = window.location.hash
  
  // 如果访问的是 /coupon/qr 或 /vehicle/invite
  // 需要检查 hash 是否正确，如果不正确（比如是 #/login 或 #/home），需要重定向到正确的路径
  if (pathname === '/coupon/qr' || pathname === '/vehicle/invite') {
    // 检查 hash 是否是正确路径
    const expectedHash = `#${pathname}`
    const hashPath = hash ? hash.split('?')[0] : '' // 提取 hash 中的路径部分（去掉查询参数）
    
    // 如果 hash 不存在，或者 hash 路径不是预期的路径（比如是 #/login 或 #/home），需要重定向
    if (!hash || (hashPath !== expectedHash && hashPath !== `#${pathname}`)) {
      const newUrl = `${expectedHash}${search}`
      console.log('[main.js] 检测到二维码URL（hash不正确），自动重定向:', {
        from: window.location.href,
        to: newUrl,
        pathname,
        search,
        hash,
        hashPath,
        expectedHash
      })
      // 使用 replace 避免在历史记录中留下记录
      // 必须在路由初始化之前执行，否则路由守卫可能会先执行并重定向到登录页
      window.location.replace(newUrl)
      // 重定向后页面会重新加载，后续代码不会执行，这是预期的行为
    }
  }
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/clearUserData'
import './permission' // 启用路由权限控制

createApp(App).use(store).use(router).mount('#app')
